import { useEntryContext } from '../context/EntryContext';

interface Props { tag?: 'h1' | 'h2' | 'h3' }

export function EntryTitleBlock({ tag: Tag = 'h1' }: Props) {
  const { entry } = useEntryContext();
  return <Tag className="font-bold text-zinc-900 leading-snug">{entry.title}</Tag>;
}
